<template>
    <div class="header">
        <div class="container" style="overflow: hidden">
            <div class="logo" @click="toIndex( menuPath.meta.needLogin)">
                <div>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="logoUrl" fit="none"></el-image>
                </div>
                <div>
                    <p>广东省动物学会</p>
                    <p>Guangdong Society of Zoology</p>
                </div>
                
            </div>
            <div class="searchbox" v-if="!menuPath.meta.needLogin">
                <input type="text" placeholder="请输入搜索内容">
                <button style="cursor:pointer">搜索</button>
            </div>
            
        </div>
        <div v-if="shareui_token" class="indexLogin">
                <span class="titleBox" @click="routerTo('AboutUs')">
                    <el-icon style="font-size:20px;vertical-align:middle"><User /></el-icon>
                    <span>{{account}}</span>
                </span>
                <span style="margin:10px">|</span>
                <span class="titleBox" @click="routerTo(null)">
                    <el-icon style="font-size:20px;vertical-align:middle"><SwitchButton /></el-icon>
                    <span>退出</span> 
                </span>
        </div>
        <div v-else class="indexLogin">
                <span class="titleBox" @click="routerTo('Login',false)">登录</span>
                <span style="margin:10px">|</span>
                <span class="titleBox" @click="routerTo('Login',true)">注册</span>
        </div>

    </div>
</template>

<script>
    import { SwitchButton,User } from "@element-plus/icons-vue";
    export default {
        name: 'HeaderView',
        components: {
            SwitchButton, User
        },
        data() {
            return {
                nowDate: null,
                menuPath:this.$route,
                logoUrl:require('@/assets/img/logo.png'),
                shareui_token:localStorage.getItem('shareui_token'),
                account:localStorage.getItem('account'),
            }

        },
        created() {
            //this.todayDate();


        },
        methods:{
            todayDate(){
                let myDate = new Date();

                let year = myDate.getFullYear(); //年

                let month = myDate.getMonth() + 1; //月

                let day = myDate.getDate(); //日

                let days = myDate.getDay();

                switch(days) {

                    case 1:

                        days = '星期一';

                        break;

                    case 2:

                        days = '星期二';

                        break;

                    case 3:

                        days = '星期三';

                        break;

                    case 4:

                        days = '星期四';

                        break;

                    case 5:

                        days = '星期五';

                        break;

                    case 6:

                        days = '星期六';

                        break;

                    case 0:

                        days = '星期日';

                        break;



                }

                this.nowDate = year + "-" + month + "-" + day + " " + days;
            },
            toIndex(val){
                if(val==true){
                    this.$router.push({
                        name: 'Application',

                    })
                }else{
                     this.$router.push({
                        name: 'Index',
                        params: {
                           id:null
                        }
                    })
                }
            },
            routerTo(name,boo){
                if(name){
                    this.$router.push({
                        name,
                        params: {
                            registershow:boo
                        }
                    })
                }else{
                    this.$confirm("确定退出登录吗？", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(() => {
                        localStorage.clear();
                        this.$router.push({
                            name: 'Login',
                        })
                    });
                }
                
            }

        }
    }
</script>

<style scoped lang="less">
.header{
    position: relative;

    .indexLogin{
        position:absolute;
        top:50px;
        right:100px;
        z-index: 100;

        .titleBox{
            cursor: pointer;
            >span{
                margin-left: 10px;
                vertical-align: middle;
            }


            &:hover{
                color: #2980C8;
            }
        }
    }
}
</style>
